
import React, { useState } from 'react';
import './App.css';
import ModalWithTabs from './ModalWithTabs'; // Adjust the path as needed
import { useEffect } from "react";
import { useLocation,Link } from "react-router-dom";


const Home = () => {
  const [showModal, setShowModal] = useState(false);
  const [defaultTab, setDefaultTab] = useState('meal-subscription');

  const openModalWithTab = (tab) => {
    setDefaultTab(tab);
    setShowModal(true);
  };
const location = useLocation();

useEffect(() => {
  if (location.hash === "#menu-section") {
    const element = document.getElementById("menu-section");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  }
}, [location]);

  return (
    <div className="homepage">
    

      {/* Hero Section */}
    <section className="hero homehero">
  <img src="img/vright.png" className="vector-left vector-desktop" alt="left vector" />
   <img src="img/m2.png" className="vectormobile-left vector-mobile" alt="left vector" />
  
  <div className="hero-content">
    <p className="subtitle">EVOLVE EVERYDAY</p>
  <h1 className="headline">
  <span style={{ color: '#2F2F2F' }}>More than just meals,</span><br />
  <span style={{ color: '#1E402E' }}>it's a lifestyle switch.</span>
</h1>


   <div className="cta-buttons">
        <center>
          <button className="subscribe-btn" onClick={() => openModalWithTab('meal-subscription')}>
            <img src="img/bticon1.png" alt="icon" className="btn-icon mobilespace" />
            Explore Meal Subscriptions
          </button>
        </center>
        <center>
          <button className="one-time-btn" onClick={() => openModalWithTab('one-time')}>
            <img src="img/btcon.png" alt="icon" className="btn-icon" />
            Order A One-Time Meal
          </button>
        </center>
      </div>
<ModalWithTabs
        show={showModal}
        onClose={() => setShowModal(false)}
        defaultTab={defaultTab}
      />

  </div>

  <img src="img/vleft.png" className="vector-right vector-desktop" alt="right vector" />
   <img src="img/m1.png" className="vectormobile-right vector-mobile" alt="right vector" />
</section>


<div className="image-slider-wrapper">
  <div className="image-slider-track">
    {[
      { src: 'img/Slid4.webp', caption: 'Test 1' },
      { src: 'img/Testimonial1.webp', caption: 'Test 1' },
      { src: 'img/Slid7.webp', caption: 'Test 1' },
       { src: 'img/Testimonial2.webp', caption: 'Test 1' },
      { src: 'img/Slid3.webp', caption: 'Test 1' },
       { src: 'img/Testimonial3.webp', caption: 'Test 1' },
      { src: 'img/Slid1.webp', caption: 'Test 1' },
       { src: 'img/Testimonial4.webp', caption: 'Test 1' },
      { src: 'img/Slid5.webp', caption: 'Test 1' },
       { src: 'img/Testimonial5.webp', caption: 'Test 1' },
      { src: 'img/Slid6.webp', caption: 'Test 1' },
    ]
      // Duplicate to simulate infinite loop
      .concat([
        { src: 'img/Slid3.webp', caption: 'Test 1' },
         { src: 'img/Slid4.webp', caption: 'Test 1' },
          { src: 'img/Slid2.webp', caption: 'Test 1' },
      ])
      .map((item, i) => (
        <div
          key={i}
          className="card-slide"
          style={{ transform: `rotate(${i % 2 === 0 ? '4deg' : '-4deg'})` }}
        >
          <img src={item.src} alt="card" />
        </div>
      ))}
  </div>
</div>


      {/* Features Section */}
      <section className="features">
        <h2 className='subheadline'>Healthy Living, <span style={{ color: '#1E402E' }}>Made Easy</span></h2>
        <p className="desc">Discover the full experience we offer, from nutrition advice to tracking tools.</p>
       <div className="feature-grid">
  <div className="feature-item">
    <img src="img/Healthy1.png" alt="Nutritionist" />
    <p className="title">Get A Nutritionist</p>
    <span className="subtitlenew">Reach out to our nutrition experts for advice</span>
  </div>
  <div className="feature-item">
    <img src="img/Healthy2.png" alt="Meal Plans" />
    <p className="title">Check Our Meal Plans</p>
    <span className="subtitlenew">Choose a personalized plan to achieve your goals</span>
  </div>
  <div className="feature-item">
    <img src="img/Healthy3.png" alt="Community" />
    <p className="title">Dynamic Community</p>
    <span className="subtitlenew">Reach out to our nutrition experts for advice</span>
  </div>
  <div className="feature-item">
    <img src="img/Healthy4.png" alt="Tracking Tools" />
    <p className="title">Diet Tracking Tools</p>
    <span className="subtitlenew">Track meals and calories in one place.</span>
  </div>
</div>

      </section>
       <div>
    <div className="nutrition-expert-wrapper">
  <div className="nutritiontried-expert-section" style={{ position: 'relative' }}>
 
    <div className="expertTried-content">
      <h2>Tried Every Diet? <a className='greencss'> Blame Your Genes</a> (Not Your Willpower).</h2>
      <p>
       Maybe carbs don't hate you. Maybe your body just has a secret manual you've never read. That's where we come in! With a little help from the science pros at <b>GeneSupport</b>.
<br/><br/>
We've teamed up to decode your genes and craft meal plans that are made for your biology.
<a className='greencss'> <b>Not just healthy, genetically correct.</b></a>
      </p>
      <a href="https://wa.me/message/BLIDE6V5JLXDA1" target="_blank" rel="noopener noreferrer" 
      className="DNASays-button">
       
       See What Your DNA Says  &gt;
      </a>
    </div>
       <div>
      <img src="img/tried.png" alt="Nutritionist" className='Triedimg' />
    </div>
  </div>
</div>
</div>
 <div className='nutritiondesktop'>
    <div className="nutrition-expert-wrapper">
  <div className="nutrition-expert-section" style={{ position: 'relative' }}>
    <div className="expert-image">
      <img src="img/img111.jpg" alt="Nutritionist" />
    </div>
    <div className="expert-content">
      <h2>Talk to Our Nutrition Experts</h2>
      <p>
        Personalized meal guidance, lifestyle tips, and support to help you stay on track — all just a message away.
      </p>
      <a href="https://wa.me/message/BLIDE6V5JLXDA1" target="_blank" rel="noopener noreferrer" className="whatsapp-button">
        <img src="img/whatsappicon.png" alt="WhatsApp" />
        Chat with us
      </a>
      <div className="hashtag-tag">#survivalofthefittest</div>
    </div>
  </div>
</div>
</div>
<div className='nutritionmobile'>
<div className="nutrition-expert-wrapper">
 <div class="nutrition-card">
  <img src="img/img111.jpg" alt="Nutritionist" class="nutrition-img" />
  <div class="text-overlay">
    <h2>Talk to Our Nutrition Experts</h2>
   <a href="https://wa.me/message/BLIDE6V5JLXDA1" target="_blank" class="chat-button">
  <img src="img/whatsappicon.png" alt="WhatsApp"/>
  <span className='chtlink'>Chat with us</span>

</a>
  </div>
</div>

</div>
</div>


<div className="menu-wrapper" id="menu-section" >
  <img src="img/psimg.png" alt="ps badge" className="corner-badge" />
<div className="menu-section">
  <h2 className="menu-title">Explore our menu</h2>
  <div className="menu-grid">

 <div className="menu-card">
      <img className='menucardimg' src="img/periperi.webp" alt="Seoul Korean Salad" />
       <div className="title-row">
    <h3>Peri Peri Chicken Salad With Honey Mustard Dressing</h3>
    <img src="img/nonvegicon.png" alt="Veg" className="veg-icon" />
  </div>
      <p className="nutrition">381 kcal | P : 30; F : 19; Carbs : 25</p>
      <p className="description">
        Peri Peri Marinated Chicken with Salad containing Lettuce, Cucumber, Broccoli, Sweetcorn, Onion, cherry tomato, Jelepenoes served with Honey Mustard Dressing
      </p>
    </div>
     <div className="menu-card">
      <img className='menucardimg' src="img/mexicanchiceknsalad.webp" alt="Seoul Korean Salad" />
       <div className="title-row">
    <h3>Mexican Chicken & Salad With Salsa And Sour Cream</h3>
    <img src="img/nonvegicon.png" alt="Veg" className="veg-icon" />
  </div>
  <p className="nutrition">492 kcal | P : 36; F : 14; Carbs : 56</p>
      <p className="description">
        Mexican Spiced marinated chicken served with salad containing  Rajma beans, sweet corns, lettuce, Salsa, served with chipotle dressing
      </p>
    </div>
     <div className="menu-card">
      <img className='menucardimg' src="img/zatarpaneer.webp" alt="Seoul Korean Salad" />
       <div className="title-row">
    <h3>Paneer Za'atar Quinoa Tabouleh Salad & Tahini Sauce</h3>
    <img src="img/vegicon.jpg" alt="Veg" className="veg-icon" />
  </div>
  <p className="nutrition">633 kcal | P : 20; F : 44; Carbs : 40</p>
      <p className="description">
        Enjoy a wholesome dish featuring tender Paneer(80g), Quinoa, and nutritious Chickpeas, combined with fresh veggies. Drizzled with Tahini Sauce, this meal offers a perfect balance of taste and nutrition.
      </p>
    </div>
    <div className="menu-card mobimenu">
      <img className='menucardimg' src="img/palakchickenbowl.webp" alt="Seoul Korean Salad" />
       <div className="title-row">
    <h3>The Palak Chicken Meal</h3>
    <img src="img/nonvegicon.png" alt="Veg" className="veg-icon" />
  </div>
   <p className="nutrition">644 kcal | P : 39; F : 25; Carbs : 67</p>
      <p className="description">
        The Palak Chicken gravy paired with green peas pulao, kachumber salad. A satisfying and flavourful meal that is both comforting and nutritious.
      </p>
    </div>

    <div className="menu-card mobimenu">
      <img className='menucardimg' src="img/srirachachickenbowl.webp" alt="Mediterranean Quinoa Bowl" />
        <div className="title-row">
  <h3>Sriracha Chicken Millet Bowl with Coconutty Sauce</h3>
    <img src="img/nonvegicon.png" alt="Veg" className="veg-icon" />
  </div>
         <p className="nutrition">704 kcal | P : 40; F : 35; Carbs : 58</p>
      <p className="description">
        Sriracha Chicken paired with tossed quinoa and roasted exotic vegetables, finished with a creamy, aromatic coconutty sauce for a rich, tropical twist.
      </p>
    </div>

    <div className="menu-card mobimenu">
      <img className='menucardimg' src="img/arabiatapasta.webp" alt="Veggie Arabiatta (Red) Wheat Pasta" />
     
       <div className="title-row">
   <h3>Veggie Arabiatta (Red) Wheat Pasta</h3>
    <img src="img/vegicon.jpg" alt="Veg" className="veg-icon" />
  </div>
   <p className="nutrition">294 kcal | P : 9; F : 7; Carbs : 49</p>
     <p className="description">
      Classic Italian Penne Pasta That Features Spicy Tomato Sauce And Exotic Vegges Topped With Olives
      </p>
    </div>

    <div className="menu-card mobimenu">
      <img className='menucardimg' src="img/burger.webp" alt="Lean Protein Cheesy Chicken Burger" />
     
        <div className="title-row">
   <h3>Lean Protein Cheesy Chicken Burger</h3>
    <img src="img/nonvegicon.png" alt="Veg" className="veg-icon" />
  </div>
  <p className="nutrition">583 kcal | P : 37; F : 26; Carbs : 50</p>
      <p className="description">
        Juicy Grilled chicken (non fried) patty on a wholesome wheat bun, topped with melted cheese and a zesty sauce. Non-fried and high in protein for a tasty, nutritious treat!
      </p>
    </div>

    <div className="menu-card mobimenu">
      <img className='menucardimg' src="img/continentalmashedpotato.webp" alt="Continental Chicken Mashed Potato Bowl" />
     
        <div className="title-row">
    <h3>Continental Chicken Mashed Potato Bowl</h3>
    <img src="img/nonvegicon.png" alt="Veg" className="veg-icon" />
  </div>
   <p className="nutrition">690 kcal | P : 36; F : 35; Carbs : 58</p>
      <p className="description">
        Enjoy Grilled Chicken served with creamy Mashed Potatoes, Grilled Veggies, and a rich White Mushroom Sauce for a flavorful and satisfying meal.
      </p>
    </div>

    <div className="menu-card setcss">
       <div className="image-row">
    <img src="img/swiggy.png" className='setimgvalue' alt="Avocado Power Salad" />
    <img src="img/zomato.png" className='setimgvalue' alt="Avocado Power Salad" />
    <img src="img/paustik.png" className='setimgvalue' alt="Avocado Power Salad" />
  </div>
      <h3>Found anything you like? Order now!</h3>
      <p className="nutrition">Explore our full menu and order instantly!</p>
    <br/> <br/>
      <center>
      <a 
  href="https://www.swiggy.com/direct/brand/156555?source=swiggy-direct&subSource=generic" 
  target="_blank" 
  rel="noopener noreferrer" 
  className="maindiv"
  style={{ textDecoration: 'none', color: 'inherit' }}
>
  <img src="img/swiggy.png" className='setimgnew' alt="Avocado Power Salad" />
  <span style={{ marginLeft: "10px", fontWeight: "500" }}>Order on Swiggy</span>
</a>
      <a 
  href="https://zomato.onelink.me/xqzv/wdky7lpc" 
  target="_blank" 
  rel="noopener noreferrer" 
  className="maindiv"
  style={{ textDecoration: 'none', color: 'inherit' }}
>
  <img src="img/zomato.png" className='setimgnew' alt="Avocado Power Salad" />
  <span style={{ marginLeft: "10px", fontWeight: "500" }}>Order on Zomato</span>
</a>
     {/* <a 
  href="https://paushtikkswitch.petpooja.site" 
  target="_blank" 
  rel="noopener noreferrer" 
  className="maindiv"
  style={{ textDecoration: 'none', color: 'inherit' }}
> */}
    <Link 
  to="https://paushtikkswitch.petpooja.site" 
  target="_blank"
  rel="noopener noreferrer" 
  className="maindiv"
  style={{ textDecoration: 'none', color: 'inherit' }}
>
  <img src="img/paustik.png" className='setimgnew' alt="Avocado Power Salad" />
  <span style={{ marginLeft: "10px", fontWeight: "500" }}>Order from us</span>
</Link>

     </center>
    </div>

  </div>
</div>
</div>

<div className='appdesktop' style={{ display: 'none' }}>
<div className="nutrition-expert-wrapper">
  <div className="nutrition-expert-section Mobileapp" style={{ position: 'relative' }}>
    <div className="expertapp-image">
      <img src="img/Mobile.png" alt="App" />
    </div>
    <div className="expertapp-content">
      <h2>Get the Paushtikk Switch App</h2>
      <p>
        Everything you need to manage your meals and health goals — all in one app.
      </p>

      <a href="https://onelink.to/xgb7ab" target="_blank" className="application-button">
        <img src="img/applicon.png" style={{ width: '20px' }} alt="Apple" />
        Download on the App Store
      </a>
      <br /><br />
      <a href="https://onelink.to/xgb7ab" target="_blank" className="application-button">
        <img src="img/plystore.png" style={{ width: '20px' }} alt="Google" />
        Get it on Google Play Store
      </a>

      <div className="hashtag2-tag">Evolve</div>
       <div className="hashtag1-tag">Everyday</div>
    </div>
  </div>
</div>
</div>
<div className='appmobileview' style={{ display: 'none' }}>
  <div className="nutrition-expert-wrapper">
  <div className="nutrition-expert-section Mobileapp">
    <div className="expertapp-image">
      <img src="img/Mobile.png" alt="App" />
    </div>
    <div className="expertapp-content">
      <h2>Get the Paushtikk Switch App</h2>
         <a href="https://onelink.to/xgb7ab" target="_blank" className="application-button">
        <img src="img/applicon.png" style={{ width: '20px' }} alt="Apple" />
        Download on the App Store
      </a>
      <a href="https://onelink.to/xgb7ab" target="_blank" className="application-button">
        <img src="img/plystore.png" style={{ width: '20px' }} alt="Google" />
        Get it on Google Play Store
      </a>

      <div className="hashtag2-tag">Evolve</div>
      <div className="hashtag1-tag">Everyday</div>
    </div>
  </div>
</div>

</div>

<div className="followdesk">
  <div className="nutrition-expert-wrapper">
  <div className="nutrition-expert-section" style={{ position: 'relative' }}>
    <div className="expert-image">
      <img src="img/281.png" alt="Nutritionist" />
    </div>
    <div className="expert-content">
      <h2>Follow us for nutritional content!</h2>
      <p>
         Join our community for daily nutrition tips, recipes, and wellness content.
      </p>
      <a href="https://www.instagram.com/paushtikkswitch/" target="_blank" rel="noopener noreferrer" className="scoial-button">
        <img src="img/instr.png" alt="WhatsApp" style={{ width: '22px' }}/>
      @paushtikkswitch
      </a>
      &nbsp;
      <a href="https://www.linkedin.com/company/paushtikk-switch-co/" target="_blank" rel="noopener noreferrer" className="scoial-button">
        <img src="img/link.png" alt="WhatsApp" style={{ width: '22px' }}/>
    Paushtikk Switch
      </a>
      <br/><br/>
      <a href="https://www.facebook.com/paushtikkswitch" target="_blank" rel="noopener noreferrer" className="scoial-button">
        <img src="img/facbok.png" alt="WhatsApp" style={{ width: '22px' }}/>
      @paushtikkswitch
      </a>
     
    </div>
  </div>
</div>
</div>
<div className="followmobile">
  <div class="nutrition-social-card">
  <img src="img/281.png" alt="Food Box" class="social-bg-img" />

  <div class="social-gradient-overlay"></div> 

  <div class="social-content">
    <h2>Follow us for nutritional content!</h2>

    <a href="https://www.instagram.com/paushtikkswitch/" class="social-button">
      <img src="img/instr.png" alt="Instagram" />
      @paushtikkswitch
    </a>

    <a href="https://www.linkedin.com/company/paushtikk-switch-co/" class="social-button">
      <img src="img/link.png" alt="LinkedIn" />
      Paushtikk Switch
    </a>

    <a href="https://www.facebook.com/paushtikkswitch" class="social-button">
      <img src="img/facbok.png" alt="Facebook" />
      @paushtikkswitch
    </a>
  </div>
</div>

</div>

    
    </div>
  );
};

export default Home;
